/* eslint-disable */

export enum BrandContentDisplayType {
	Unspecified = 0,
	Hide = 1,
	ScrollPast = 2,
	
}
